import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

const Disclaimer = ({ openModal }) => {
  return (
    <div className="legal-page">
      <header className="legal-hero">
        <div className="legal-hero-inner">
          <nav className="legal-breadcrumbs" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span className="bc-separator">/</span>
            <span>Disclaimer</span>
          </nav>
          <span className="legal-badge">Medical & General Advisory</span>
          <h1>Medical & General Disclaimer</h1>
          <p className="legal-hero-lead">
            Important advisory regarding the educational and promotional nature of the information provided on the Embrace Beauty Aesthetics website and individual treatment expectations.
          </p>
          <div className="legal-meta">
            <div className="legal-meta-item">
              <span>📅 Effective Date: October 2025</span>
            </div>
            <div className="legal-meta-item">
              <span>📍 Embrace Beauty Aesthetics Clinic</span>
            </div>
          </div>
        </div>
      </header>

      <main className="legal-main">
        <div className="legal-container">
          <article className="legal-card">
            <div className="legal-toc">
              <div className="legal-toc-title">Quick Navigation</div>
              <ul className="legal-toc-list">
                <li><a href="#section-1">1. General Information Only</a></li>
                <li><a href="#section-2">2. Medical & Clinical Disclaimer</a></li>
                <li><a href="#section-3">3. Individual Treatment Results</a></li>
                <li><a href="#section-4">4. Photography & Testimonials</a></li>
                <li><a href="#section-5">5. External Links & Third-Party Resources</a></li>
                <li><a href="#section-6">6. Limitation of Liability</a></li>
                <li><a href="#section-7">7. Emergency Guidance</a></li>
              </ul>
            </div>

            <section className="legal-section" id="section-1">
              <div className="legal-section-header">
                <span className="legal-section-num">01</span>
                <h2>General Information Only</h2>
              </div>
              <p>
                The information provided on this website—including articles, treatment descriptions, FAQs, blog posts, and educational guides—is intended solely for general informational and educational purposes.
              </p>
              <p>
                Nothing contained on this website should be construed as establishing a doctor-patient relationship, offering definitive medical diagnosis, prescribing treatments, or dispensing clinical medical advice.
              </p>
            </section>

            <section className="legal-section" id="section-2">
              <div className="legal-section-header">
                <span className="legal-section-num">02</span>
                <h2>Medical & Clinical Disclaimer</h2>
              </div>
              <p>
                Always consult directly with a licensed physician, certified medical aesthetician, or qualified healthcare professional concerning any personal medical condition, aesthetic concern, or intended regimen.
              </p>
              <p>
                Never disregard professional medical advice, delay seeking diagnosis, or discontinue prescribed treatments because of something you have read on this website or on our digital social channels.
              </p>
              <div className="legal-callout warning">
                <h4>⚠️ Medical Emergency Notice</h4>
                <p>
                  If you are experiencing a medical emergency, severe allergic reaction, or acute physical distress, call <strong>911</strong> or visit the nearest emergency medical facility immediately. Do not rely on website communication or contact forms for urgent medical needs.
                </p>
              </div>
            </section>

            <section className="legal-section" id="section-3">
              <div className="legal-section-header">
                <span className="legal-section-num">03</span>
                <h2>Individual Treatment Results</h2>
              </div>
              <p>
                Aesthetic, anti-aging, skincare, and restorative treatments produce individual results that can vary substantially from client to client.
              </p>
              <ul className="legal-list">
                <li>Outcomes depend on individual biological factors, genetics, lifestyle, skin tone and condition, age, adherence to pre-care and post-care protocols, and metabolism.</li>
                <li>Embrace Beauty Aesthetics makes no warranties, guarantees, or explicit representations that you will achieve the exact results demonstrated in marketing visuals or reported by other clients.</li>
                <li>All prospective treatments require an initial in-person assessment by our licensed aesthetic specialists to determine appropriateness and establish realistic expectations.</li>
              </ul>
            </section>

            <section className="legal-section" id="section-4">
              <div className="legal-section-header">
                <span className="legal-section-num">04</span>
                <h2>Photography & Testimonials</h2>
              </div>
              <p>
                Before-and-after photographs, video demonstrations, and patient reviews exhibited across our website depict real client experiences with their explicit permission.
              </p>
              <p>
                These representations are illustrative only and do not serve as a clinical promise or guarantee of comparable outcomes for every individual.
              </p>
            </section>

            <section className="legal-section" id="section-5">
              <div className="legal-section-header">
                <span className="legal-section-num">05</span>
                <h2>External Links & Third-Party Resources</h2>
              </div>
              <p>
                For your convenience, our website may include hyperlinks to external websites, suppliers, and third-party financing platforms (such as Cherry Payment Plans).
              </p>
              <p>
                Embrace Beauty Aesthetics does not oversee, endorse, or assume responsibility for the accuracy, completeness, privacy practices, or content of third-party platforms. Accessing external links is undertaken at your own discretion.
              </p>
            </section>

            <section className="legal-section" id="section-6">
              <div className="legal-section-header">
                <span className="legal-section-num">06</span>
                <h2>Limitation of Liability</h2>
              </div>
              <p>
                By navigating and utilizing this website, you acknowledge and agree that Embrace Beauty Aesthetics, its medical directors, clinicians, employees, and agents shall not be held liable for any direct, indirect, special, incidental, or consequential damages resulting from the use of, or inability to use, this site or reliance upon any material provided herein.
              </p>
            </section>

            <section className="legal-section" id="section-7">
              <div className="legal-section-header">
                <span className="legal-section-num">07</span>
                <h2>Schedule Your In-Person Consultation</h2>
              </div>
              <p>
                The safest and most effective way to understand your options and achieve your aesthetic goals is through a personalized, one-on-one consultation with our expert team.
              </p>
              <ul className="legal-list">
                <li><strong>Phone:</strong> <a href="tel:+14694341574">+1 469-434-1574</a></li>
                <li><strong>Hours:</strong> 9 AM - 10 PM, Monday - Saturday</li>
                <li><strong>Location:</strong> Embrace Beauty Aesthetics Clinic</li>
              </ul>
            </section>

            <div className="legal-help-box">
              <h3>Ready to Discuss Your Aesthetic Goals?</h3>
              <p>
                Schedule an in-depth consultation with our experienced clinical team today to discover tailored treatments suitable for you.
              </p>
              <div className="legal-help-actions">
                <button className="btn-primary" onClick={openModal}>Make Appointment</button>
                <a href="tel:+14694341574" className="btn-outline">Call +1 469-434-1574</a>
                <Link to="/" className="btn-outline">Back to Home</Link>
              </div>
            </div>
          </article>
        </div>
      </main>
    </div>
  );
};

export default Disclaimer;
